/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
/**
 * @module Store/files
 * @description Module for file handling
 */

/**
 * @constant State of files store
 * @type {object}
 * @description This constant holds the state of files store
 * */
const state = {
};

/**
 * @constant Getters
 * @type {object}
 * @description This constant represents the getters for the files store
 * */
const getters = {
};

/**
 * @constant Mutations
 * @type {object}
 * @description This constant represents the mutations for the files store
 * */
const mutations = {
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async uploadFilesForLayoutAsync ({rootState}, {files}) {
        let body = new FormData();
        for(let i = 0; i < files.length; i++) {
            body.append(`${files[i].name}`, files[i]);

        }
        try {
            let {data} = await Vue.axios.post(`${rootState.config.coldStoragePort}/store`, body, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'multipart/form-data'
                }
            });
            return {data};
        } catch (err) {
            return {err: err};
        }
    },
    async getImage ({rootState}, storeId) {
        try {
            let {data} = await Vue.axios.get(`${rootState.config.coldStoragePort}/store/${storeId}`, {
                responseType: 'arraybuffer'
            });
            //eslint-disable-next-line
            return {data: new Buffer(data, 'binary').toString('base64')};
        } catch (err) {
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
